import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { message, Modal } from 'antd';
import { store } from 'utils/httpUtil';
import history from 'utils/history';

export const useMerchantOnboardHook = () => {
  const { id } = useParams();
  const [selectedSerials, setSelectedSerials] = useState([]);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const terminalInfos = (data?.outlets || []).reduce((acc, outlet) => {
    const outletTerminalInfos = (outlet?.terminals || []).map(terminal => {
      const selectedTerminal = selectedSerials.find(item => item.mmsId === terminal?.mmsId);

      return {
        mmsId: terminal?.mmsId,
        serialNumber: selectedTerminal?.serialNumber || terminal?.serialNumber || '',
      };
    });

    return [...acc, ...outletTerminalInfos];
  }, []);

  const allSerialNumbersSelected =
    terminalInfos.length > 0 && terminalInfos.every(terminal => Boolean(terminal.serialNumber));

  const approveMerchant = async payload => {
    setLoading(true);
    try {
      const response = await store(`terminals/v1/third-party/mps/approve`, payload);
      if (response?.data?.message === 'SUCCESS') {
        setData(response.data.data || []);
        history.push(`/merchants/onboard-auto`);
        message.success('Successfully approved merchant changes.');
      } else {
        setData([]);
        message.error('Something Went Wrong. Please try again.');
      }
    } catch (error) {
      history.push(`/merchants/onboard-auto`);
      message.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  const rejectMerchant = async payload => {
    setLoading(true);
    try {
      const response = await store(`terminals/v1/third-party/mps/reject`, payload);
      if (response?.data?.message === 'SUCCESS') {
        setData(response.data.data || []);
        history.push(`/merchants/onboard-auto`);
        message.error('Successfully rejected merchant changes.');
      } else {
        setData([]);
      }
    } catch (error) {
      history.push(`/merchants/onboard-auto`);

      message.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };
  const fetchMerchantDetail = async id => {
    setLoading(true);
    try {
      const response = await store(`terminals/v1/third-party/mps/detail`, { id });

      if (response?.data?.message === 'SUCCESS') {
        setData(response.data.data);
      } else {
        message.warning('Unexpected API response format');
      }
    } catch (error) {
      message.error('Failed to fetch merchant details');
    } finally {
      setLoading(false);
    }
  };

  const onAccept = () => {
    approveMerchant({
      id: data?.id,
      terminalInfos: selectedSerials,
    });
  };
  const onReject = () =>
    Modal.confirm({
      title: 'Reject changes?',
      content: 'Please confirm rejection and provide a reason in the next step.',
      onOk: () => {
        rejectMerchant({
          id: data?.id,
        });
      },
    });

  useEffect(() => {
    if (id) {
      fetchMerchantDetail(id);
    }
  }, [id]);
  return {
    loading,
    data,
    onAccept,
    onReject,
    setSelectedSerials,
    selectedSerials,
    allSerialNumbersSelected,
  };
};
